/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ebenezer's Portfolio",
  description:
    "Resourceful and diversified IT professional with strong taste for high quality and good standard practices, a proficient developer, with expertise in Web Development, Python programming, Java programming and SQL.",
  og: {
    title: "Ebenezer Arkoh-Addo Portfolio",
    type: "website",
    url: "earkohaddo.peoplesbest.net",
  },
};

//Home Page
const greeting = {
  title: "Ebenezer Arkoh-Addo",
  logo_name: "Arkoh-Addo",
  nickname: "Software Engineer | IT Support Specialist",
  subTitle: "Software Engineer | IT Support Specialist",
  roleBadge: "Independent Contractor",
  resumeLink: "https://www.linkedin.com/in/earkohaddo/",
  portfolio_repository: "https://github.com/arkohaddoebenezer",
  githubProfile: "https://github.com/arkohaddoebenezer",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/arkohaddoebenezer",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/earkohaddo/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:arkohaddoebenezer21@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://web.facebook.com/arkohaddo",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/earkohaddo/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development (Heavy Backend)",
      fileName: "FullStackImg",
      skills: [
        "⚡ UI/UX Enhancement & Frontend Optimization",
        "⚡ Application Security & Vulnerability Mitigation",
        "⚡ Performance Tuning & Memory Optimization",
        "⚡ RESTful API Design & Development",
        "⚡ Database Architecture, Design & Management",
        "⚡ DevOps Practices & CI/CD Pipeline Integration",
        "⚡ Scalable Software Architecture & Design Patterns",
      ],
      softwareSkills: [
        {
          skillName: "Springboot",
          fontAwesomeClassname: "simple-icons:springboot",
          style: {
            color: "green",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "skill-icons:laravel-dark",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Vue",
          fontAwesomeClassname: "skill-icons:vuejs-light",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "logos:docker-icon",
          style: {
            color: "green",
          },
        },
        {
          skillName: "K8s",
          fontAwesomeClassname: "skill-icons:kubernetes",
          style: {
            color: "green",
          },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "logos:rabbitmq",
          style: {
            color: "green",
          },
        },
        {
          skillName: "Kafka",
          fontAwesomeClassname: "logos:kafka",
          style: {
            color: "green",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "skill-icons:mysql-light",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: {
            color: "#DC382D",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F1502F",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "logos:jenkins",
          style: {
            color: "#D24939",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "logos:jira",
          style: {
            color: "#0052CC",
          },
        },
      ],
    },
    {
      title: "IT Support Specialist",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ IT Consultancy & Technical Advisory",

        "⚡ Operating System Support (Windows, Linux, Ubuntu, macOS)",

        "⚡ Computer and Mobile Device Repairs & Unlocking",

        "⚡ LAN Setup, Network Administration & Security Management",

        "⚡ Software Installation, Configuration & Issue Resolution",

        "⚡ Data Backup, Restoration & Disaster Recovery Planning",

        "⚡ IT System Maintenance & Performance Optimization",

        "⚡ Technical Support & Issue Troubleshooting",

        "⚡ Cloud Services & Basic Cloud Infrastructure Management",
      ],
      softwareSkills: [
        {
          skillName: "Windows",
          fontAwesomeClassname: "famicons:logo-windows",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "skill-icons:linux-light",
          style: {
            color: "#CCC",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "System Units",
          fontAwesomeClassname: "simple-icons:system76",
          style: {
            color: "#FF5370",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/earkohaddo/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/arkohaddoebenez1/hackos",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/earkohaddo",
    },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Valley View University",
      subtitle: "Bsc. Information Technology",
      logo_path: "valley_view.png",
      alt_name: "VVU",
      duration: "2021 - 2023",
      descriptions: [
        "Some key programs I studied",
        "⚡ Machine Learning Algorithms",
        "⚡ Computer Vision",
        "⚡ Computer & Cyber Forensics",
        "⚡ Human Computer Interactions",
        "⚡ Advanced Database System Implementation & Administration",
        "⚡ Systems and Network Analysis Administration",
      ],
      website_link: "https://www.vvu.edu.gh/",
    },
    {
      title: "Koforidua Technical university",
      subtitle: "Higher National Diploma Computer Science",
      logo_path: "ktu_logo.png",
      alt_name: "KTU",
      duration: "2018 - 2021",
      descriptions: [
        "Some key programs I studied",
        "⚡ Data Structure and Algorithms",
        "⚡ Object Oriented Programming with Java",
        "⚡ Object Oriented Programming with C++",
        "⚡ Web Based Applications",
        "⚡ Relational Database Management System",
        "⚡ Computer Hardware",
        "⚡ Computer Network Management",
        "⚡ Operation Research",
        "⚡ Project Management",
      ],
      website_link: "https://www.ktu.edu.gh/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Technical Support Fundamentals",
      subtitle: "Google",
      logo_path: "technical_support_fundamentals.png",
      certificate_link: "https://www.coursera.org/verify/2V7QSHTNYMJN",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Google IT Support Professional",
      subtitle: "Google",
      logo_path: "google_it.jpeg",
      certificate_link:
        "https://coursera.org/share/b894bbf5add223a2e8c257e3f5a370aa",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "HCIA Routing & Switching",
      subtitle: "Huawei",
      logo_path: "hcia_routing_switching.png",
      certificate_link:
        "https://drive.google.com/file/d/1Q7lKVSzmiUdU5J_nESeEFVJV3CnlPu6K/view?usp=sharing",
      alt_name: "HCIA",
      color_code: "#00000099",
    },
    {
      title: "Network Security Specialist",
      subtitle: "ICSI",
      logo_path: "icsi_badge.png",
      certificate_link:
        "https://drive.google.com/file/d/1TpgnJK9cq7G7L2c_sjPKFZN7JTBBqHFQ/view?usp=sharing",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Full Stack Engineer",
      subtitle: "AMALITECH",
      logo_path: "amalitech.png",
      certificate_link:
        "https://drive.google.com/file/d/1oaQxwPsSC96xH8vqS1LqRueyFQ5J0pPl/view?usp=sharing",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "IT Security: Defense Against Digital Art",
      subtitle: "Google",
      logo_path: "google_logo.png",
      certificate_link: "https://coursera.org/verify/HLAJMKSDWHR8",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Java Developer",
      subtitle: "IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.youracclaim.com/go/bNJyxyvS",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },

    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Professional Experience",
  subtitle: "Work, Internship and Volunteers",
  description:
    "I have worked with evolving startups as a Developer, contributing to growth with planning, decision making and innovative solutions. I have also worked with well established companies as IT Technician and a Developer, gaining enterprise scale experience across diverse domains. I have a startup IT company, collaborating with a team of six talented professionals, developing software solutions and providing on-demand IT Support services.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Backend Engineer",
          company: "Amalitech (Graduate Trainee Programme)",
          company_url: "https://amalitech.com/graduate-trainee-programme/",
          logo_path: "amalitech.png",
          duration: "June 2024 - December 2024",
          location: "Kumasi",
          description:
            "Graduate Trainee Programme is an intensive, full-time IT skills development programme designed to equip participant with the knowledge and practical experience needed to thrive in the growing IT industry.",
          color: "#212121",
        },
        {
          title: "Full Stack Developer",
          company: "Zeder Technologies",
          company_url: "https://zedertech.com/",
          logo_path: "zeder.png",
          duration: "May 2023 - To Present",
          location: "Remote Worker",
          description:
            "As a trusted partner to top enterprises, SMEs, and tech pioneers, Zeder Technologies empowers businesses to realize their full potential. I been a staff since May 2023.",
          color: "#9b1578",
          raw_html:
            "<div> <h4 class='repo-description' >Key Contributions</h4><ul>" +
            "<li>Need assessment: Meeting with clients to understand their specific needs. Ask questions to clarify project requirements and determine the best technical solutions to meet the client's needs</li>" +
            "<li>UX/UI: Design an attractive and user-friendly interface for projects. Work on the layout, colors, fonts, and images to create an enjoyable user experience.</li>" +
            "<li>Software Development: Use a variety of programming languages to develop front-end and back-end software for the projects. Work with frameworks such as Vue.js, Inertia.js, Laravel to create a robust and scalable application.</li>" +
            "<li>Testing and maintenance: Write unit and Feature test to ensure application is functioning correctly and is free of bugs. Provide technical support and ongoing maintenance to ensure the proper ftlnctioning applications.</li>" +
            "<li>DevOps</li>" +
            "</ul></div>",
        },
        {
          title: "IT Technician Assistant(NSS)",
          company: "Ghana Navy",
          company_url: "https://navyonline.mil.gh/",
          logo_path: "ghana_navy_logo.png",
          duration: "November 2021 - September 2022",
          location: "Accra, Burma Camp",
          description:
            "I worked with the Ghana Navy IT Department for a year while on national service assignment. On daily basis during the period I responded to calls from various offices and attended to their IT needs and also performed the following duties and more",
          color: "#0879bf",
          raw_html: `<div> <h4 class='repo-description' >Network Administration</h4><ul>
          <li>Monitored network for down times and reported to my superiors</li>
          <li>Helped troubleshoot network to resolve down times</li>
          <li>Routing and Switching</li>
          <li>Huawei Router Configuration</li>
          <li>Cisco Router Configuration</li>
          <li>Network cable termination and connecting devices to the network</li>
        </ul>
        <h4 class='repo-description' >System Administration</h4>
        <ul>
          <li>Managed active directort users (Resetting forgotten password, create new users etc)</li>\
          <li>Managed shared drive and access previleges</li>
          <li>Windows Operating System</li>
          <li>Software installations, upgrades and troubleshooting</li>
          <li>Cisco Router Configuration</li>
          <li>Microsoft Office Suite</li>
        </ul>
        <h4 class='repo-description' >Repair and Maintenance</h4>
        <ul>
          <li>Printer</li>
          <li>Monitors</li>
          <li>System Units</li>
        </ul> </div>`,
        },
        {
          title: "Chief Technology Officer",
          company: "Ananse Technology Hub",
          company_url: "https://anansetechhub.com/",
          logo_path: "ananse.png",
          duration: "Januarry 2019 - To Date",
          description:
            "I have a proven record of success in leading and transforming my organization as an accomplished and visionary CEO. With a strong focus on strategic planning, innovation, and team development, My company has consistently delivered outstanding results and driven business growth for our clients.",
          color: "#fc1f20",
          raw_html:
            "<div> <ul>" +
            "<li>I led the expansion into new markets and diversified the company's service offerings to meet evolving customer needs</li>" +
            "<li>I implemented agile development methodologies, resulting in increased development speed and improved product quality.</li>" +
            "<li>I have developed key customer relationships and negotiated major contracts, for the company.</li>" +
            "<li>I lead the team in development and implementation of projects</li>" +
            "<li>I strengthened the executive team and implement talent development programs to enhance the organizational capabilities.</li>" +
            "</ul></div>",
        },
      ],
    },
    {
      title: "Internships And Trainings",
      experiences: [
        {
          title: "AWS Cloud Practioner",
          company: "Amalitech (Re-Start Programme)",
          company_url: "https://amalitech.com/aws-re-start-programme/",
          logo_path: "restart.png",
          duration: "December 2023 - Febuary 2024",
          location: "Remote Worker",
          description:
            "AWS re/Start is a free, 12-week, full-time skills development programme that prepares unemployed or underemployed individuals for entry-level careers in the cloud.",
          color: "#212121",
        },
        {
          title: "Full Stack Developer",
          company: "AmaliTech (Graduate Trainee Programme)",
          company_url: "https://amalitech.com/graduate-trainee-programme/",
          logo_path: "amalitech.png",
          duration: "November 2021 - April 2022",
          location: "Remote Worker",
          description:
            "Graduate Trainee Programme is an intensive, full-time IT skills development programme designed to equip participant with the knowledge and practical experience needed to thrive in the growing IT industry.",
          color: "#000000",
        },
        {
          title: "Backend Developer",
          company: "77Developers",
          company_url: "https://www.77developers.com/",
          logo_path: "77developers.png",
          duration: "May 2022 - Sept 2022",
          location: "Remote Worker",
          description:
            "With 77Developers as intern I made contributions to the project revoltafrica. Revolt Africa is a platform for streaming quality african music. As a backend developer",
          color: "#ee3c26",
          raw_html: `<ul>
          <li>I developed and maintained APIs for serving mobile apps</li>
        </ul>`,
        },
      ],
    },
    {
      title: "Volunteers",
      experiences: [
        {
          title: "Editor",
          company: "WikiMedia Foundation",
          company_url: "https://wikimediafoundation.org/",
          logo_path: "wiki_media.png",
          duration: "January 2019 - March 2019",
          location: "Linda Dor, Koforidua",
          description:
            "I contributed to editing documentations on wikipedia, adding credible reference and citations to existing articles",
          color: "#4285F4",
        },
        {
          title: "Web Master",
          company: "Universal Hall",
          company_url: "https://universalhall.blogspot.com/",
          logo_path: "universal_logo.jpg",
          duration: "August 2019 - May 2021",
          location: "Universal Hall, Koforidua",
          description:
            "As a computer science student at level 200 and a member of the prestigious hall of KTU. I was presented with the privilege to manage the blogging website of the hall. During my 2 year period as the web master,",
          color: "#D83B01",
          raw_html: `<ul>
          <li>I developed a consistent posting schedule, delivering valuable and relatable content to readers.</li>
          <li>Social Media Management: I created facebook page for the hall and leveraged the platform to promote blog content, engaging readers.</li>
          <li>I engaged with readers through comments and social media, fostering a sense of community and encouraging discussions.</li>
          </ul> </div>`,
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "My Works",
  description:
    "I have made significant contribution to the following projects as part of a team or as a sole developer",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "aster=1",
      name: "Aster Designs GH",
      folder: "aster",
      createdAt: "2020-03-06T16:26:54Z",
      description: "An ecommerce website for aster design company",
      url: "https://asterdesignsgh.com/",
      logo_path: "aster/aster_home.png",
      screenshots: [
        "aster_home.png",
        "aster_new.png",
        "aster_all.png",
        "aster_footer.png",
        "aster_fabrics.png",
      ],
    },
    {
      id: "tellertill=1",
      name: "TellerTill",
      folder: "tellertillapp",
      createdAt: "2020-03-06T16:26:54Z",
      description:
        "Cash digitisation infrastructure that converts physical cash into instantly credited digital money, combining secure hardware with agent, admin, and reconciliation workflows",
      url: "https://tellertill.com/",
      logo_path: "tellertillapp/tellertill_home.jpg",
      screenshots: ["tellertill_home.jpg"],
    },
    {
      id: "ramenlegal=1",
      name: "RamenLegal",
      folder: "ramenlegal",
      createdAt: "2020-03-06T16:26:54Z",
      description:
        "AI-powered legal documentation platform that automates the creation of contracts, company policies, and other critical business documents",
      url: "https://ramen.legal/",
      logo_path: "ramenlegal/ramenlegal_home.jpg",
      screenshots: ["ramenlegal_home.jpg"],
    },
    {
      id: "poultryup=1",
      name: "PoultryUp",
      folder: "poultryup",
      createdAt: "2020-03-06T16:26:54Z",
      description:
        "A complete poultry farm management system for tracking bird batches, feeding, egg production, health, and performance analytics",
      url: "https://erafarms.poultryup.com/",
      logo_path: "poultryup/poultryup_home.jpg",
      screenshots: ["poultryup_home.jpg"],
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=1",
      name:
        "Vitez Delivery Backend Services, Administration website and Mobile Apps",
      folder: "vitez",
      createdAt: "2020-03-06T16:26:54Z",
      description:
        "A comprehensive system developed to streamline delivery operations for Vitez Delivery Company, including backend infrastructure, administrative management, and mobile apps for riders and users",
      url: "https://vitezdelivery.com/",
      logo_path: "vitez/vitez_website.png",
      screenshots: [
        "vitez_website.png",
        "vitez_user_app.png",
        "vitez_rider_app.png",
        "vitez_dashboard.png",
      ],
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=8",
      name: "Zeder Technologies Official Website",
      folder: "zeder",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Official website for Zeder Technologies",
      url: "https://zedertech.com/",
      logo_path: "zeder/zeder_home.png",
      screenshots: [
        "zeder_home.png",
        "zeder_contact.png",
        "zeder_service.png",
        "zeder_services.png",
      ],
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=2",
      name: "USPX Cargo and Shipping",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Logistic website for tracking deliveries",
      url: "https://uspxcargoandshipping.com/",
      logo_path: "uspx.png",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=3",
      name: "Peoples Best",
      createdAt: "2020-03-06T16:26:54Z",
      description:
        "Clean, beautiful, responsive and customizable portfolio platform for every profession",
      url: "https://www.peoplesbest.net",
      logo_path: "star-profile.png",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=4",
      name: "Swift World Remit",
      createdAt: "2020-03-06T16:26:54Z",
      description: "A finance app for remittance and customer support",
      url: "https://swiftworldremit.com/",
      logo_path: "swiftworld.png",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=5",
      name: "Paramedic Aid Co. Ltd Official Website",
      createdAt: "2020-03-06T16:26:54Z",
      description:
        "Website for a first aid training company in Ghana showcasing their supplies and gallery of their training sessions",
      url: "https://www.paclgh.org/",
      logo_path: "paclgh.png",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=6",
      name: "Meta Skeletoid Club",
      createdAt: "2020-03-06T16:26:54Z",
      description: "A web platform for advertising NFTs",
      url: "https://metaskeletoidclub.blogspot.com/",
      logo_path: "meta_skeletoid.png",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=7",
      name: "Universal Hall Blogging Site",
      createdAt: "2020-03-06T16:26:54Z",
      description: "A blogging website for universal hall of KTU",
      url: "https://universalhall.blogspot.com/",
      logo_path: "universalhall.png",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "earkohaddo.png",
    description:
      "I am available on almost every social media with the username earkohaddo. You can message me anytime, I typically reply within 24 hours. Get in touch let's talk about the next project",
  },
  blogSection: {
    title: "Ebenezer Arkoh-Addo",
    subtitle: "Tel: 0572945773/0531506124",
    link: "mailto:arkohaddoebenezer21@gmail.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "P.O Box CT 7364",
    locality: "Kanodar",
    country: "IN",
    region: "Gujarat",
    postalCode: "385520",
    streetAddress: "Ambavadi vas",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
